import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Navbar from "../layout/Menu";
import DrawerMenu from "../layout/DrawerMenu";
import { useDispatch } from "react-redux";
import { menuAction } from "../redux/reducers/Menu";
import {collection, getDoc, addDoc, doc} from 'firebase/firestore';
import db from "../config/firebase";

const ProtectedRoute = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [userRegistered, setUserRegistered] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  React.useEffect(() => {
    const checkUser = async () => {
      if (localStorage.getItem("htuser")) {
        let userId = localStorage.getItem("htuser");

        const docRef = doc(db, "user", `${userId}`);
        const docSnap = await getDoc(docRef);
        if (!docSnap.exists()) {
          setErrorMessage("You have not access!");
          navigate("/");

          dispatch(menuAction());
        } else {
          setUserRegistered(true);
        }

      } else {
        setErrorMessage("You have not access!");
        navigate("/");

        dispatch(menuAction());
      }
    };

    checkUser();
  }, []);

  return (
    <>
      {userRegistered ? (
        <Grid container>
          <Navbar />
          <Grid
            item
            xs={12}
            sx={(theme) => ({
              marginTop: `${theme.mixins.toolbar.minHeight}px`,
              paddingTop: ".4rem",
            })}
          >
            <DrawerMenu />
          </Grid>
          <Grid item xs={12} sx={(theme) => ({ paddingTop: `.4rem` })}>
            <Outlet />
          </Grid>
        </Grid>
      ) : (
        <div>{errorMessage}</div>
      )}
    </>
  );
};

export default ProtectedRoute;
